import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Expand = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Expand" {...props}>
    <path d="M9.29297 13.293C9.68349 12.9024 10.3165 12.9024 10.707 13.293C11.0976 13.6835 11.0976 14.3165 10.707 14.707L4.41406 21H8C8.55228 21 9 21.4477 9 22C9 22.5523 8.55228 23 8 23H2C1.73478 23 1.48051 22.8946 1.29297 22.707C1.10543 22.5195 1 22.2652 1 22V16C1 15.4477 1.44772 15 2 15C2.55228 15 3 15.4477 3 16V19.5859L9.29297 13.293Z" fill="#000" /><path d="M22 1C22.5523 1 23 1.44772 23 2V8C23 8.55228 22.5523 9 22 9C21.4477 9 21 8.55228 21 8V4.41406L14.707 10.707C14.3165 11.0976 13.6835 11.0976 13.293 10.707C12.9024 10.3165 12.9024 9.68349 13.293 9.29297L19.5859 3H16C15.4477 3 15 2.55228 15 2C15 1.44772 15.4477 1 16 1H22Z" fill="#000" />
  </StyledIcon>
));

Expand.displayName = 'Expand';

export { Expand };
